import { render } from "./AdminRegister.vue?vue&type=template&id=4c3cca70&scoped=true&ts=true"
import script from "./AdminRegister.vue?vue&type=script&lang=ts"
export * from "./AdminRegister.vue?vue&type=script&lang=ts"

import "./AdminRegister.vue?vue&type=style&index=0&id=4c3cca70&scoped=true&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3cca70"]])

export default __exports__